
import { useEffect, useState } from "react";


const STORAGE_KEY = "mobikode_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const handleConsent = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch {
      // Continue if browser storage is unavailable.
    }

    setVisible(false);

    window.dispatchEvent(
      new CustomEvent("mobikode-cookie-consent", {
        detail: { choice },
      })
    );
  };

  if (!visible) return null;

  return (
    <div
      className="mk-cookie-popup"
      role="dialog"
      aria-label="Cookie preferences"
      aria-describedby="mk-cookie-description"
    >
      <div className="mk-cookie-heading">
       
        <h3>We Value Your Privacy</h3>
      </div>

      <p id="mk-cookie-description">
        We use cookies to improve your browsing experience,
        analyze website traffic, and support our services.
        You can accept or reject optional cookies.
      </p>

      <div className="mk-cookie-actions">
        <button
          type="button"
          className="mk-cookie-btn mk-cookie-accept"
          onClick={() => handleConsent("accepted")}
        >
          Accept All
        </button>

        <button
          type="button"
          className="mk-cookie-btn mk-cookie-reject"
          onClick={() => handleConsent("rejected")}
        >
          Reject All
        </button>
      </div>

      <a href="/privacy-policy" className="mk-cookie-policy">
        Privacy Policy
      </a>
    </div>
  );
}
